import Vue from 'vue'
import { bankConfig } from '@/views/payroll/config.js'
const $t = Vue.prototype.$t

export const info = {
  // common: { // 基础信息
  //   title: 'common',
  //   type: 'common',
  // },
  staff_info: {
    // 员工信息
    title: '3',
    type: 'staff_info'
  },
  payroll: {
    // 工资数据
    title: '1006',
    type: 'payroll'
  },
  attendance: {
    // 考勤数据
    title: '1007',
    type: 'attendance'
  },
  tax: {
    // 税
    title: '421',
    type: 'tax'
  },
  social_security: {
    // 社保
    title: '420',
    type: 'social_security'
  },
  provident_fund: {
    // 公积金
    title: '1456',
    type: 'provident_fund'
  }
}

export const allColumn = ['staff_info', 'payroll', 'attendance', 'tax', 'social_security', 'provident_fund']
/**
 *  type 类型
 *  1 date 时间
 *  2 input 输入框
 *  3 select 下拉框
 *  4 inputSelect input下拉框 see:  https://element.eleme.cn/#/zh-CN/component/input
 */

export const common = [
  // 姓名
  {
    label: $t('22'),
    prop: 'staff_name',
    fixed: true,
    custom: 'custom',
    isShow: [1, 2, 99],
    align: 'left',
    width: '264'
  }
]
export const NetPay = [
  // Net Pay
  {
    label: $t('389'),
    prop: 'total_net_pay',
    fixed: 'right',
    isShow: [1, 2, 99],
    width: '168px'
  }
]

// 员工信息
export const staff_info = [
  // 工号
  {
    label: $t('25'),
    fixed: '',
    custom: 'custom',
    align: 'left',
    prop: 'staff_code',
    isShow: [1, 2, 99],
    width: '160px'
  },
  // 手机号
  {
    label: $t('825'),
    fixed: '',
    align: 'left',
    prop: 'staff_phone',
    isShow: [1, 2, 99],
    width: '168px'
  },
  // 部门
  {
    label: $t('27'),
    prop: 'department_name',
    isShow: [1, 2, 99],
    align: 'left',
    width: '120px'
  },
  // 职位
  {
    label: $t('24'),
    prop: 'job_title',
    isShow: [1, 2, 99],
    align: 'left',
    width: '120px'
  },
  // 税
  {
    label: $t('421'),
    align: 'left',
    prop: 'tax_deduction_status',
    type: 'select',
    options: [
      { value: '1', label: $t('basic_info_1') },
      { value: '3', label: $t('basic_info_1') },
      { value: '4', label: $t('basic_info_2') },
      { value: '2', label: $t('942') }
    ],
    isShow: [1, 2, 99],
    width: '192px'
  },
  // 计算规则
  {
    label: $t('457'),
    prop: 'tax_rule_text',
    align: 'left',
    isShow: [1, 2, 99],
    width: '192px'
  },
  // 社保
  {
    label: $t('420'),
    prop: 'social_security_status',
    type: 'select',
    align: 'left',
    options: [
      { value: '1', label: $t('940') },
      { value: '2', label: $t('941') }
    ],
    isShow: [1, 2, 99],
    width: '168px'
  },
  // 公积金
  {
    label: $t('1490'),
    prop: 'provident_fund_status',
    type: 'select',
    align: 'left',
    options: [
      { value: '1', label: $t('1475') },
      { value: '2', label: $t('1476') }
    ],
    isShow: [1, 2, 99],
    width: '192px'
  },
  // 税id
  {
    label: $t('429'),
    prop: 'tax_id',
    align: 'left',
    width: '168px'
  },
  // 员工属性
  {
    label: $t('32'),
    prop: 'staff_formal',
    type: 'select',
    align: 'left',
    options: [
      { value: '1', label: $t('938') },
      { value: '2', label: $t('939') }
    ],
    isShow: [1, 2, 99],
    width: '168px'
  },
  // 结算类型
  {
    label: $t('33'),
    prop: 'settlement_type',
    type: 'select',
    align: 'left',
    options: [
      { value: '1', label: $t('401') },
      { value: '2', label: $t('400') },
      { value: '99', label: $t('402') }
    ],
    isShow: [1, 2, 99],
    width: '168px'
  },
  // 发薪方式
  {
    label: $t('34'),
    prop: 'pay_method',
    type: 'select',
    align: 'left',
    options: [
      { value: '1', label: $t('403') },
      { value: '2', label: $t('404') }
    ],
    isShow: [1, 2, 99],
    width: '168px'
  },
  // 银行
  {
    label: $t('417'),
    prop: 'bank_name',
    type: 'select',
    childProp: 'bank_name',
    align: 'left',
    options: bankConfig,
    isShow: [1, 2, 99],
    width: '168px'
  },
  // 银行卡号
  {
    label: $t('418'),
    prop: 'bank_card_no',
    childProp: 'bank_card_no',
    align: 'left',
    options: bankConfig,
    isShow: [1, 2, 99],
    width: '168px'
  },
  // 入职日期
  {
    label: $t('28'),
    prop: 'hire_date',
    isShow: [1, 2, 99],
    align: 'left',
    width: '192px'
  },
  // 离职日期
  {
    label: $t('29'),
    prop: 'leave_date',
    isShow: [1, 2, 99],
    align: 'left',
    width: '192px'
  }
]

// 税
// export const tax = [
//   // {
//   //   label: $t('1458'),
//   //   prop: 'tax_deduction_7',
//   //   edit: true,
//   //   isShow: [1, 2]
//   // },
//   // {
//   //   label: $t('943', { x: 2 }),
//   //   prop: 'tax_deduction_8',
//   //   edit: true,
//   //   isShow: [1, 2]
//   // },
//   // {
//   //   label: $t('943', { x: 3 }),
//   //   prop: 'tax_deduction_9',
//   //   edit: true,
//   //   isShow: [1, 2]
//   // },
//   // {
//   //   label: $t('943', { x: 4 }),
//   //   prop: 'tax_deduction_10',
//   //   edit: true,
//   //   isShow: [1, 2]
//   // },
//   // {
//   //   label: $t('943', { x: 5 }),
//   //   prop: 'tax_deduction_11',
//   //   edit: true,
//   //   isShow: [1, 2]
//   // },
//   // {
//   //   label: $t('943', { x: 6 }),
//   //   prop: 'tax_deduction_12',
//   //   edit: true,
//   //   isShow: [1, 2]
//   // },
//   // {
//   //   label: $t('943', { x: 4 }),
//   //   prop: 'tax_deduction_13',
//   //   edit: true,
//   //   isShow: [1, 2]
//   // },
//   // {
//   //   label: $t('943', { x: 5 }),
//   //   prop: 'tax_deduction_14',
//   //   edit: true,
//   //   isShow: [1, 2]
//   // },
//   // {
//   //   label: $t('943', { x: 6 }),
//   //   prop: 'tax_deduction_15',
//   //   edit: true,
//   //   isShow: [1, 2]
//   // },
//   {
//     label: $t('446'),
//     prop: 'tax_start_month',
//     edit: true,
//     type: 'date',
//     rules: { type: 'month', valueFormate: 'yyyy-MM' },
//     isShow: [1, 2]
//   },
//   { label: $t('944'), prop: 'salary_last_fix', edit: true, isShow: [1, 2] },
//   { label: $t('1233'), prop: 'salary_year_accumulate_fix_tax', edit: true, isShow: [1, 2] },
//   { label: $t('1230'), prop: 'salary_year_accumulate_notfix', edit: true, isShow: [1, 2] },
//   { label: $t('1231'), prop: 'salary_year_accumulate_notfix_tax', edit: true, isShow: [1, 2] },
//   { label: $t('1234'), prop: 'salary_year_calculate_total', edit: true, isShow: [1, 2] },
//   { label: $t('945'), prop: 'salary_month_fix', isShow: [1, 2] },
//   {
//     label: $t('947'),
//     prop: 'tax_person_consumption_deduction',
//     isShow: [1, 2]
//   },
//   { label: $t('946'), prop: 'tax_person_burden_deduction', isShow: [1, 2] },
//   { label: $t('1009'), prop: 'tax_person_ss_deduction', isShow: [1, 2] },
//   { label: $t('501'), prop: 'salary_year_fix', isShow: [1, 2] },
//   { label: $t('948'), prop: 'salary_year_net_pay', isShow: [1, 2] },
//   { label: $t('949'), prop: 'salary_month_fix_tax', isShow: [1, 2] },
//   { label: $t('955'), prop: 'salary_month_notfix_tax_amount', isShow: [1, 2] },
//   { label: $t('510'), prop: 'salary_month_notfix_tax', isShow: [1, 2] },
//   { label: $t('514'), prop: 'salary_month_tax', isShow: [1, 2] }
// ]

// 社保
export const social_security = [
  { label: $t('448'), prop: 'salary_last_ss', isShow: [1, 2] },
  { label: $t('956'), prop: 'social_security_base', isShow: [1, 2] },
  //
  { label: $t('1771'), prop: 'social_security', isShow: [1, 2, 99] },
  { label: $t('1772'), prop: 'social_security_amount', isShow: [1, 2, 99] },
  { label: $t('1773'), prop: 'social_security_company', isShow: [1, 2, 99] },
  { label: $t('1774'), prop: 'social_security_amount_company', isShow: [1, 2, 99] }
]
